import { Button, Dialog } from '@mui/material';
import CloseModalButton from '../../../components/CloseModalButton';
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from '../../../components/Dialog.styled';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { deleteWaterlineRoom } from '../../../services/waterlineService';
import { Room } from './types';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { addError } from '../../../redux/alerts';
import { selectCurrentCustomerNumber } from '../../../redux/customer';

interface RoomModalProps {
  onClose: (refresh?: boolean, refreshAll?: boolean) => void;
  isOpen: boolean;
  room?: Room;
}

const DeleteRoomModal: React.FC<RoomModalProps> = ({ onClose, isOpen, room }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const customerNumber = useAppSelector(selectCurrentCustomerNumber);


  const handleSubmit = async () => {
    setLoading(true);

    if (!room) {
      return;
    }

    try {
      await deleteWaterlineRoom(customerNumber, room.room_id);
      onClose(false, true);
    } catch (error) {
      const message = 'There was an error deleting the room';
      console.error(message);
      dispatch(addError(message));
      onClose(false);
    }

    setLoading(false);
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} fullWidth>
      <CloseModalButton handleClose={() => onClose(false)} />
      <StyledDialogTitle>Delete Room/Chair</StyledDialogTitle>
      <StyledDialogContent>
        <div className="flex flex-center m-b-16">
          <DeleteIcon fontSize="large" />
        </div>
        <div className="m-b-16 center">
          Deleting an existing room/chair will lead to unassigning the test results from that room/chair if already assigned. Are you sure you delete
          the existing room/chair?
        </div>
        <div className="bold">Room/Chair: {room?.name}</div>
      </StyledDialogContent>
      <StyledDialogFooter>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          Delete
        </Button>
      </StyledDialogFooter>
    </Dialog>
  );
};

export default DeleteRoomModal;
